import { createFileRoute } from "@tanstack/react-router";
import ExternalRecipients from "@/components/ExternalRecipients";

function RouteComponent() {
  return <ExternalRecipients />;
}

export const Route = createFileRoute("/_authenticated/external-recipients/")({
  component: RouteComponent,
  staticData: { page: "banking" },
});
